import PropTypes from "prop-types";

// MUI
import { Dialog, DialogTitle, IconButton, Grid, Box } from "@mui/material";

// Icons
import CloseIcon from "@mui/icons-material/Close";

const CommonDialog = ({ open, onClose, title, className, children }) => (
	<Dialog open={open} onClose={onClose} aria-labelledby="dialog-title" className={className} maxWidth="xl" fullWidth={true}>
		<DialogTitle id="dialog-title" className="!p-0">
			<Box display="flex" justifyContent="space-between" alignItems="center">
				<span>{title}</span>
				<Box flexGrow={1} />
				<IconButton aria-label="close" onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</Box>
		</DialogTitle>
		<Grid>{children}</Grid>
	</Dialog>
);

CommonDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	children: PropTypes.node,
	className: PropTypes.string,
};

export default CommonDialog;
